import React, { useState } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SearchForm = styled.form`
  display: flex;
  gap: 10px;
`;

const SearchInput = styled.input`
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

const SearchButton = styled.button`
  background-color: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0 20px;
  cursor: pointer;
  font-size: 16px;
  
  &:hover {
    background-color: #5a6acf;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

const FilterLabel = styled.label`
  font-size: 14px;
  color: #666;
`;

const FilterSelect = styled.select`
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
`;

const SearchBar = ({ onSearch }) => {
  const [searchText, setSearchText] = useState('');
  const [creatorFilter, setCreatorFilter] = useState('');
  const [sortBy, setSortBy] = useState('newest');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({
      query: searchText,
      creator: creatorFilter,
      sortBy
    });
  };

  return (
    <SearchContainer>
      <SearchForm onSubmit={handleSubmit}>
        <SearchInput
          type="text"
          placeholder="Search by prompt or description..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <SearchButton type="submit">Search</SearchButton>
      </SearchForm>
      
      <FilterContainer>
        <FilterLabel>
          Creator:
          <SearchInput
            type="text"
            placeholder="Filter by creator..."
            value={creatorFilter}
            onChange={(e) => setCreatorFilter(e.target.value)}
            style={{ width: '150px', padding: '5px 10px' }}
          />
        </FilterLabel>
        
        <FilterLabel>
          Sort by:
          <FilterSelect value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="newest">Newest first</option>
            <option value="oldest">Oldest first</option>
          </FilterSelect>
        </FilterLabel>
      </FilterContainer>
    </SearchContainer>
  );
};

export default SearchBar;